import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "Common/Auth/auth.css";

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className="ciq-auth">
      <aside className="ciq-auth__brand">
        <div className="ciq-auth__brand-bg" />
        <div className="ciq-auth__brand-inner">
          <a className="ciq-brand" href="https://coreiqpro.com">
            <img src={`${process.env.PUBLIC_URL}/logo-icon.png`} alt="CoreIQPro" />
            <span className="ciq-brand__txt">
              Core<span className="o">IQ</span>Pro
            </span>
          </a>
          <h1 className="ciq-auth__headline">Access restricted.</h1>
          <p className="ciq-auth__sub">
            You are signed in, but you do not have permission to view this page.
          </p>
        </div>
      </aside>

      <main className="ciq-auth__panel">
        <div className="ciq-auth__card">
          <div className="ciq-auth__card-head">
            <div>
              <h2>403, access denied</h2>
              <p className="ciq-auth__muted">This page is not available for your account.</p>
            </div>
          </div>

          <div className="ciq-auth__msg error">
            <div className="ciq-auth__msg-title">No permission</div>
            If you believe this is a mistake, please contact your administrator.
          </div>

          <Button type="primary" block onClick={() => navigate(-1)}>
            Go back
          </Button>

          <div className="ciq-auth__foot">
            <Button type="link" onClick={() => navigate("/login")}>
              Sign in with a different account
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Forbidden;
